import React, { useRef, useState } from 'react'
import ReactDOM from 'react-dom'

const OFFSET = 14

// Cuts the text with an ellipsis only when it does not fit its cell.
// Hovering a cut-off text shows the full text in a tooltip that follows the cursor.
const OverflowText = ({ text = '', cursor }) => {
  const ref = useRef(null)
  const [pos, setPos] = useState(null)

  const move = (e) => {
    const el = ref.current
    if (!el || el.scrollWidth <= el.clientWidth) {
      setPos(null)
      return
    }
    setPos({ x: e.clientX, y: e.clientY })
  }

  return (
    <>
      <span
        ref={ref}
        className='d-block text-truncate'
        style={cursor ? { cursor } : undefined}
        onMouseEnter={move}
        onMouseMove={move}
        onMouseLeave={() => setPos(null)}>
        {text}
      </span>
      {pos &&
        ReactDOM.createPortal(
          <div
            role='tooltip'
            className='s7'
            style={{
              position: 'fixed',
              left: pos.x + OFFSET,
              top: pos.y + OFFSET,
              maxWidth: 320,
              padding: '4px 8px',
              background: '#fff',
              color: '#000',
              border: '1px solid rgba(0, 0, 0, 0.2)',
              borderRadius: 4,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              pointerEvents: 'none',
              zIndex: 2000,
            }}>
            {text}
          </div>,
          document.body,
        )}
    </>
  )
}

export default OverflowText
